import React from "react";
import { Helmet } from "react-helmet-async";
import Card from "@mui/material/Card";

import MKBox from "components/MKBox";
import GoogleTrustIndex from "components/GoogleTrustIndex";
import HeroSection from "pages/Servicii/ServiciiSpeciale/CuratenieCliniciCabineteMedicale/sections/sections/HeroSection";
import ArticleContent from "pages/Servicii/ServiciiSpeciale/CuratenieCliniciCabineteMedicale/sections/sections/ArticleContent";

function CuratenieCliniciCabineteMedicale() {
    return (
        <>
            <Helmet>
                <title>Curățenie pentru clinici și cabinete medicale în București | Doral Cleaning</title>
                <meta
                    name="description"
                    content="Servicii profesionale de curățenie pentru clinici și cabinete medicale din București, adaptate zonelor, programului și cerințelor de igienă. Cere o ofertă."
                />
                <link rel="canonical" href="https://doral-cleaning.ro/curatenie-clinici-cabinete-medicale/" />
                <script type="application/ld+json">
                    {`
                    {
                        "@context": "https://schema.org",
                        "@type": "FAQPage",
                        "mainEntity": [
                            {
                                "@type": "Question",
                                "name": "Ce include curățenia profesională într-o clinică?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Depinde de evaluarea spațiului și de contract. În mod obișnuit intră recepția, sala de așteptare, holurile, grupurile sanitare, pardoselile, suprafețele accesibile și mobilierul din zonele generale."
                                }
                            },
                            {
                                "@type": "Question",
                                "name": "Cât costă curățenia pentru o clinică sau un cabinet medical?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Nu există un preț unic, pentru că tariful depinde de suprafață, de zonele incluse, de frecvență și de intervalul în care se lucrează. Venim la fața locului pentru o evaluare gratuită și ofertă personalizată."
                                }
                            },
                            {
                                "@type": "Question",
                                "name": "Firma de curățenie se ocupă de toate zonele unei clinici?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Nu neapărat. Responsabilitățile se delimitează clar între prestator și personalul medical al clinicii înainte de începerea contractului. Zonele estetice (sticlă, clanțe, urme) sunt exact cele care scapă când personalul medical se concentrează pe cabinete."
                                }
                            },
                            {
                                "@type": "Question",
                                "name": "Curățarea și dezinfecția sunt același lucru?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Nu. Curățarea îndepărtează murdăria mecanic, iar dezinfecția distruge microorganismele patogene cu biocide avizate. Normele sanitare le reglementează distinct."
                                }
                            },
                            {
                                "@type": "Question",
                                "name": "Doral Cleaning sterilizează instrumentarul medical?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Nu. Sterilizarea instrumentarului rămâne exclusiv în sarcina personalului medical autorizat al clinicii."
                                }
                            },
                            {
                                "@type": "Question",
                                "name": "Curățenia poate fi realizată după programul clinicii?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Da, intervențiile pot fi stabilite înainte de deschidere, după încheierea programului sau în weekend."
                                }
                            }
                        ]
                    }
                    `}
                </script>
                <script type="application/ld+json">
                    {`
                    {
                        "@context": "https://schema.org",
                        "@type": "Service",
                        "name": "Curățenie clinici și cabinete medicale",
                        "provider": {
                            "@type": "LocalBusiness",
                            "name": "Doral Cleaning - Servicii profesionale de curatenie",
                            "image": "https://i.ibb.co/d08GpF5b/image-41.jpg",
                            "telephone": "0730 407 322",
                            "address": {
                                "@type": "PostalAddress",
                                "streetAddress": "Calea Șerban Vodă 82, Sector 4, 040213 București",
                                "addressLocality": "București",
                                "addressCountry": "RO"
                            }
                        },
                        "areaServed": {
                            "@type": "City",
                            "name": "București"
                        },
                        "description": "Servicii profesionale de curățenie pentru clinici și cabinete medicale în București și Ilfov."
                    }
                    `}
                </script>
            </Helmet>
            <HeroSection />
            <Card
                sx={{
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    zIndex: 1,
                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                    backdropFilter: "saturate(200%) blur(30px)",
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                    overflow: "hidden",
                }}
            >
                <ArticleContent />
            </Card>
            <MKBox pt={6} px={1} mt={6}>
                <GoogleTrustIndex />
            </MKBox>
        </>
    );
}

export default CuratenieCliniciCabineteMedicale;
